import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import { DescriptionIcon, ExpandableText } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

export interface DescriptionCardProps {
  description: string;
  disabledEditor?: boolean;
  onClick?: () => void;
}

const DescriptionCard = ({ description, disabledEditor, onClick }: DescriptionCardProps) => {
  const { t } = useTranslation();
  const onClickHandler = useCallback(() => {
    if (disabledEditor) return;
    onClick?.();
  }, [disabledEditor, onClick]);

  return (
    <Flex gap="2.5" cursor={disabledEditor ? 'default' : 'pointer'} onClick={onClickHandler}>
      <Box fontSize="4xl" pt="3.5">
        <DescriptionIcon />
      </Box>
      <Stack gap="1" flex="1" pt="3.5" borderTop="1px solid" borderColor="border.subtle">
        <Text fontSize="sm" fontWeight="semibold">
          {t('chatSettings.description')}
        </Text>
        <ExpandableText
          fontSize="xs"
          color="fg.muted"
          buttonColor="brand"
          text={description || t('chatSettings.noDescription')}
        />
      </Stack>
    </Flex>
  );
};

const MemoizedDescriptionCard = memo(DescriptionCard);
export { MemoizedDescriptionCard as DescriptionCard };
